
import React from 'react';

interface MessageContentProps {
  content: string;
}

const MessageContent: React.FC<MessageContentProps> = ({ content }) => {
  return (
    <div className="message-text-container">
      <div className="message-text">
        {content}
      </div>
    </div>
  );
};

export default MessageContent;
